import { motion } from 'framer-motion'
import React from 'react'
import styled from 'styled-components'

const Loader = ({ setLoad }) => {

    const container = {
        show: {
            transition: {
                staggerChildren: 0.3,
            },
        },
    };

    const loadVariant = {
        hidden: { opacity: 0, y: 200 },
        show: {
            opacity: 1,
            y: '0%',
            transition: {
                duration: 2,
                ease: [0.65, 0, 0.35, 1]
            }
        },
        exit: {
            opacity: 0,
            y: '-200%',
            transition: {
                ease: [0.83, 0, 0.17, 1],
                duration: 1,
            },
        }
    };

    const itemMain = {
        hidden: { opacity: 0, y: 200 },
        show: {
            opacity: 1,
            y: 0,
            transition: {
                ease: [0.83, 0, 0.17, 1],
                duration: 1.6,
            },
        },
    };

    return (
        <LoaderDiv className='loader'>

            <motion.div
                onAnimationComplete={() => setLoad(false)}
                variants={container}
                initial="hidden"
                animate="show"
                exit="exit"
            >
                <motion.div
                    className='innerLoad'
                >
                    <motion.span
                        variants={loadVariant}
                        className='innerTxt1'> G </motion.span>
                </motion.div>

                <motion.div
                    className='innerLoad'
                >
                    <motion.span
                        variants={loadVariant}
                        className='innerTxt2'> A </motion.span>
                </motion.div>

                <motion.div
                    variants={itemMain}
                    className='loadImage'
                >
                    <motion.img src='/logo.png' layoutId='logo-1' />

                </motion.div>

                <motion.div

                    className='innerLoad'
                >
                    <motion.span
                        variants={loadVariant}
                        className='innerTxt3'> G </motion.span>
                </motion.div>

                <motion.div
                    className='innerLoad'
                >
                    <motion.span
                        variants={loadVariant}
                        className='innerTxt4'> A </motion.span>
                </motion.div>

                <motion.div
                    className='innerLoad'
                >
                    <motion.span
                        variants={loadVariant}
                        className='innerTxt5'> N </motion.span>
                </motion.div>

            </motion.div>
        </LoaderDiv>
    )
}

export default Loader

const LoaderDiv = styled(motion.div)`
    height: 100vh;
    width: 100vw;
    position: relative;
    z-index: 100;
    overflow: hidden;

    div{
        height: 100vh;
        width: 100vw;
        display: flex;
        align-items: center;
        justify-content: center;

        .loadImage{
            display: flex;
            align-items: center;
            justify-content: center;
            position: absolute;
            height: 30%;
            width: 20%;

            @media only screen and (max-width: 1024px) {
                width: 40% !important;
            }
            @media only screen and (max-width: 915px) {
                width: 40% !important;
            }
            
            @media only screen and (max-width: 500px) {
                width: 60% !important;
            }

            @media only screen and (max-width: 410px) {
                width: 80% !important;
            }
            @media only screen and (max-width: 315px) {
                width: 55% !important;
                height: 20% !important;
            }
            
            img{
                height: 100%;
                width: 100%;
                object-fit:cover;
            }
        }

        .innerLoad{
            display: flex;
            align-items: center;
            overflow: hidden;
            justify-content: center;
            
            .innerTxt1{
                position: absolute;
                left: 16%;
                top: 14%;
                @media only screen and (max-width: 915px) {
                    top: 10% !important;
                    left: 10% !important;
                }
                
            }
            .innerTxt2{
                position: absolute;
                right: 12%;
                top: 8%;
            }
            .innerTxt3{
                position: absolute;
                right: 50%;
                bottom: 10%;

                @media only screen and (max-width: 915px) {
                    bottom: 7% !important;
                }

                @media only screen and (max-width: 410px) {
                    right: 40% !important;
                }

                @media only screen and (max-width: 315px) {
                    bottom: 13% !important;
                }
                
            }
            .innerTxt4{
                position: absolute;
                left: 14%;
                bottom: 12%;

                @media only screen and (max-width: 915px) {
                    bottom: 7% !important;
                }
                
            }
            .innerTxt5{
                position: absolute;
                bottom: 10%;
                right: 20%;
                
                @media only screen and (max-width: 915px) {
                    bottom: 5% !important;
                    right: 10% !important;
                }
                
            }
            span{
                font-size: 6rem;
                font-family: var(--font1);

                @media only screen and (max-width: 500px) {
                    font-size: 4rem !important;
                }
            }
        }
    }
`